import React, { useState, useEffect, useRef } from "react";
import { useCookies } from 'react-cookie';
import Sidebar from './SideBar';
import useAuthRedirect from "./Componentes/auth";
import Axios from 'axios';
import config from './Componentes/config';
import { registrarLog } from './Componentes/logService';
import Swal from 'sweetalert2';
import { generarContratoPDF, TURNO_DIA_DEFAULT, TURNO_NOCHE_DEFAULT } from './Documentos/Contrato';
import { getEmpresaByCodigo } from './Componentes/empresasConfig';

const cardImages = {
    DAFA: "/img/dafaLogo.png",
    FUGA: "/img/fugarLogo.png",
    INVE: "/img/idafaLogo.png",
    TRAN: "/img/extasisLogo.png",
    NIDI: "/img/nidiamLogo.png"
};

const buildDefaults = (codigo) => {
    const e = getEmpresaByCodigo(codigo);
    return {
        empresa: e.nombre,
        rutEmpresa: e.rutFormatted,
        representanteLegal: e.representanteLegal,
        rutRepresentante: e.rutRepresentante,
        domicilioEmpresa: `${e.domicilio}, Comuna de ${e.comuna}`,
        emailEmpleador: "administracion@grupoidafa.cl", // valor por defecto editable
        ciudad: e.ciudad,
    };
};

// Plantilla de funciones por defecto
const funcionesDefault = [
    "Consolidado de camiones, encarpado y desencarpado",
    "Recepción y despacho de harina, enganche, vaciado y llenado de maxi saco, pesaje jumbo.",
    "Asistencia en recepción, carga y descarga de aceite.",
    "Aseo en bodegas y exteriores",
    "Ensacado general (manual y automático) u otra actividad que tenga directa relación con el cargo ya indicado."
];

// ==================== COMPONENTE INPUT REUTILIZABLE (fuera del componente para evitar pérdida de foco) ====================
const FormInput = ({ label, field, type = "text", placeholder = "", options = null, value, onChange }) => {
    if (options) {
        return (
            <div className="input-group input-group-sm mb-2">
                <span className="input-group-text" style={{ minWidth: '150px', fontSize: '12px' }}>{label}</span>
                <select className="form-select form-select-sm" value={value} onChange={(e) => onChange(field, e.target.value)}>
                    {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                </select>
            </div>
        );
    }
    return (
        <div className="input-group input-group-sm mb-2">
            <span className="input-group-text" style={{ minWidth: '150px', fontSize: '12px' }}>{label}</span>
            <input
                type={type}
                className="form-control form-control-sm"
                value={value}
                onChange={(e) => onChange(field, e.target.value)}
                placeholder={placeholder}
            />
        </div>
    );
};

// ==================== SECCION COLAPSABLE (fuera del componente para evitar pérdida de foco) ====================
const AccordionSection = ({ id, title, icon, isOpen, onToggle, children, maxHeight = '600px' }) => {
    return (
        <div className="card mb-2">
            <div
                className="card-header py-2 d-flex align-items-center justify-content-between"
                style={{ cursor: 'pointer', backgroundColor: isOpen ? '#e8f0fe' : '#f8f9fa' }}
                onClick={() => onToggle(id)}
            >
                <h6 className="m-0" style={{ fontSize: '13px', fontWeight: '600' }}>
                    <span className="material-symbols-rounded" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '6px' }}>{icon}</span>
                    {title}
                </h6>
                <span className="material-symbols-rounded" style={{ fontSize: '18px', transition: 'transform 0.2s', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                    expand_more
                </span>
            </div>
            <div style={{ maxHeight: isOpen ? maxHeight : '0', overflow: 'hidden', transition: 'max-height 0.3s ease-in-out' }}>
                <div className="card-body py-2 px-3">
                    {children}
                </div>
            </div>
        </div>
    );
};

function Contratos() {
    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard']);
    const imageUrl = cardImages[cookies.selectedCard];
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);
    const [isAdministracionCollapsed, setIsAdministracionCollapsed] = useState(true);
    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prevState => !prevState);
    };

    const idEmpresa = cookies.idEmpresa;
    const selectedCard = cookies.selectedCard;

    const empresa = getEmpresaByCodigo(cookies.selectedCard).nombre;

    // Estado de secciones colapsables del formulario
    const [openSection, setOpenSection] = useState('empresa');

    // Datos del contrato
    const defaults = buildDefaults(selectedCard);

    const [formData, setFormData] = useState({
        // Datos empresa
        ciudad: defaults.ciudad,
        empresa: defaults.empresa,
        rutEmpresa: defaults.rutEmpresa,
        representanteLegal: defaults.representanteLegal,
        rutRepresentante: defaults.rutRepresentante,
        domicilioEmpresa: defaults.domicilioEmpresa,
        emailEmpleador: defaults.emailEmpleador,
        // Datos trabajador
        nombreTrabajador: "",
        nacionalidad: "CHILENO",
        fechaNacimiento: "",
        estadoCivil: "SOLTERO",
        afp: "",
        rutTrabajador: "",
        previsionSalud: "FONASA",
        domicilioTrabajador: "",
        comunaTrabajador: "",
        emailTrabajador: "",
        // Datos cargo
        cargo: "",
        lugarTrabajo: "",
        direccionTrabajo: "",
        comunaTrabajo: "",
        // Condiciones laborales
        horasSemanales: "42",
        sueldoBase: "",
        sueldoTexto: "",
        bonoMovilizacion: "40.000",
        bonoMovilizacionTexto: "cuarenta mil pesos",
        // Tipo y vigencia
        tipoContrato: "PLAZO FIJO",
        fechaInicioContrato: "",
        fechaFinContrato: "",
        // Rut Provisorio (trabajadores extranjeros no regularizados)
        rutProvisorio: false,
        rutProvisorioNumero: "",
        numeroContacto: "",
    });

    // Funciones del cargo (editables)
    const [funciones, setFunciones] = useState([...funcionesDefault]);
    const [nuevaFuncion, setNuevaFuncion] = useState("");

    // Jornada (precargada desde el contrato, editable: agregar / modificar / eliminar)
    const [turnoDia, setTurnoDia] = useState([...TURNO_DIA_DEFAULT]);
    const [turnoNoche, setTurnoNoche] = useState(TURNO_NOCHE_DEFAULT.map(r => ({ ...r })));
    const [nuevaLineaDia, setNuevaLineaDia] = useState("");

    // Ref para scroll a la vista previa
    const previewRef = useRef(null);

    // Logo como base64 para marca de agua en PDF
    const [logoBase64, setLogoBase64] = useState(null);

    useEffect(() => {
        // Cargar el logo como base64 para pdfmake
        const loadLogo = async () => {
            try {
                const response = await fetch('/img/dafaLogoPDF.png');
                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setLogoBase64(reader.result);
                };
                reader.readAsDataURL(blob);
            } catch (err) {
                console.error('Error cargando logo para marca de agua:', err);
            }
        };
        loadLogo();
    }, []);

    // Actualizar datos empresa cuando cambia la card
    useEffect(() => {
        const d = buildDefaults(selectedCard);
        setFormData(prev => ({
            ...prev,
            empresa: d.empresa,
            rutEmpresa: d.rutEmpresa,
            representanteLegal: d.representanteLegal,
            rutRepresentante: d.rutRepresentante,
            domicilioEmpresa: d.domicilioEmpresa,
            emailEmpleador: d.emailEmpleador,
            ciudad: d.ciudad,
        }));
    }, [selectedCard]);

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const agregarFuncion = () => {
        if (nuevaFuncion.trim()) {
            setFunciones(prev => [...prev, nuevaFuncion.trim()]);
            setNuevaFuncion("");
        }
    };

    const eliminarFuncion = (index) => {
        setFunciones(prev => prev.filter((_, i) => i !== index));
    };

    // --- Turno de día (líneas de texto) ---
    const agregarLineaDia = () => {
        if (nuevaLineaDia.trim()) {
            setTurnoDia(prev => [...prev, nuevaLineaDia.trim()]);
            setNuevaLineaDia("");
        }
    };
    const modificarLineaDia = (index, value) => {
        setTurnoDia(prev => prev.map((l, i) => i === index ? value : l));
    };
    const eliminarLineaDia = (index) => {
        setTurnoDia(prev => prev.filter((_, i) => i !== index));
    };

    // --- Turno de noche (filas de rotación) ---
    const agregarFilaNoche = () => {
        setTurnoNoche(prev => [...prev, { entranteDia: "", entranteHora: "", salienteDia: "", salienteHora: "" }]);
    };
    const modificarFilaNoche = (index, campo, value) => {
        setTurnoNoche(prev => prev.map((r, i) => i === index ? { ...r, [campo]: value } : r));
    };
    const eliminarFilaNoche = (index) => {
        setTurnoNoche(prev => prev.filter((_, i) => i !== index));
    };

    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    // Formatear fecha para mostrar
    const formatFecha = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr + "T00:00:00");
        const meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
        return `${String(date.getDate()).padStart(2, '0')} de ${meses[date.getMonth()]} del ${date.getFullYear()}`;
    };

    // Formatear RUT chileno con puntos y guion (12345678K -> 12.345.678-K).
    // Si el cuerpo no es numérico (DNI extranjero o placeholder), devuelve el valor sin tocar.
    const formatRut = (rut) => {
        if (!rut) return rut;
        const clean = String(rut).replace(/[.\-\s]/g, '').toUpperCase();
        if (clean.length < 2) return rut;
        const body = clean.slice(0, -1);
        const dv = clean.slice(-1);
        if (!/^\d+$/.test(body)) return rut;
        const bodyFmt = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${bodyFmt}-${dv}`;
    };

    // Verificar si un valor es placeholder
    const isPlaceholder = (value) => {
        return !value || value.trim() === "";
    };

    // Renderizar texto con placeholders resaltados en la vista previa
    const renderText = (value, label) => {
        if (isPlaceholder(value)) {
            return <span className="placeholder-highlight" style={{
                backgroundColor: '#fff3cd',
                border: '1px dashed #ffc107',
                padding: '1px 4px',
                borderRadius: '3px',
                cursor: 'pointer',
                fontSize: 'inherit'
            }}>[{label}]</span>;
        }
        return <span>{value}</span>;
    };

    // ==================== REGISTRAR TRABAJADOR ====================
    const registrarTrabajador = () => {
        const d = formData;
        // Validar campos obligatorios del trabajador
        const camposRequeridos = ['nombreTrabajador', 'rutTrabajador', 'cargo', 'sueldoBase',
            'fechaInicioContrato', 'comunaTrabajador', 'domicilioTrabajador'];
        if (d.rutProvisorio) camposRequeridos.push('rutProvisorioNumero');
        const faltantes = camposRequeridos.filter(f => isPlaceholder(d[f]));

        if (faltantes.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Campos obligatorios',
                text: `Faltan ${faltantes.length} campo(s) obligatorio(s) para registrar al trabajador.`,
            });
            return;
        }

        // Separar nombre completo en nombres y apellidos
        const partes = d.nombreTrabajador.trim().split(/\s+/);
        let nombres, apellidos;
        if (partes.length >= 4) {
            nombres = partes.slice(0, 2).join(' ');
            apellidos = partes.slice(2).join(' ');
        } else if (partes.length === 3) {
            nombres = partes[0];
            apellidos = partes.slice(1).join(' ');
        } else {
            nombres = partes[0] || '';
            apellidos = partes.slice(1).join(' ') || '';
        }

        // El RUT para cotización/registro:
        //   - Con Rut Provisorio (extranjero): se usa el Rut Provisorio chileno
        //   - Sin Rut Provisorio: se usa el RUT del trabajador
        const rutParaRegistro = d.rutProvisorio ? d.rutProvisorioNumero : d.rutTrabajador;
        const rutLimpio = rutParaRegistro.replace(/\./g, '').replace(/-/g, '');

        // Limpiar sueldo (quitar puntos y caracteres no numéricos)
        const sueldoLimpio = d.sueldoBase.replace(/\./g, '').replace(/[^0-9]/g, '');

        Swal.fire({
            title: 'Confirmar registro',
            html: `<p>Se registrará al trabajador:</p>
                   <p><strong>${d.nombreTrabajador}</strong></p>
                   <p>${d.rutProvisorio ? 'Rut Provisorio' : 'RUT'}: ${rutParaRegistro}</p>
                   ${d.rutProvisorio ? `<p>DNI: ${d.rutTrabajador}</p>` : ''}
                   <p>Cargo: ${d.cargo}</p>
                   <p>Y se generará el contrato en PDF.</p>`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Registrar y generar PDF',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                Axios.post(`${config.API_URL}/CreaTrabajador`, {
                    empresa: idEmpresa,
                    nombres: nombres,
                    apellidos: apellidos,
                    nacionalidad: d.nacionalidad,
                    fechaNacimiento: d.fechaNacimiento,
                    estadoCivil: d.estadoCivil,
                    afp: d.afp,
                    rut: rutLimpio,
                    prevision: d.previsionSalud,
                    domicilio: d.domicilioTrabajador,
                    comuna: d.comunaTrabajador,
                    cargo: d.cargo,
                    sueldoB: sueldoLimpio,
                    tipoContrato: d.tipoContrato,
                    vigenciaDesde: d.fechaInicioContrato,
                    vigenciaHasta: d.fechaFinContrato || '',
                    centroCosto: '',
                    sueldoBase: d.sueldoBase
                }).then(() => {
                    registrarLog({
                        Usuario: cookies.usuario,
                        Modulo: 'Contratos',
                        Detalle: `Registro de trabajador desde Contratos: ${d.nombreTrabajador}`,
                        Estado: 'Exito',
                    });
                    Swal.fire({
                        title: 'Trabajador registrado',
                        text: 'El trabajador fue registrado exitosamente. Generando PDF...',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    // Generar PDF automáticamente después del registro
                    setTimeout(() => {
                        buildAndGeneratePDF(true);
                    }, 1500);
                }).catch((error) => {
                    console.error('Error al registrar trabajador:', error);
                    registrarLog({
                        Usuario: cookies.usuario,
                        Modulo: 'Contratos',
                        Detalle: `Registro de trabajador desde Contratos: ${d.nombreTrabajador}`,
                        Estado: 'Fallo',
                    });
                    Swal.fire({
                        title: 'Error',
                        text: 'No se pudo registrar al trabajador. Verifique los datos e intente nuevamente.',
                        icon: 'error',
                    });
                });
            }
        });
    };

    // Contar placeholders sin completar
    const countEmptyFields = () => {
        const required = ['nombreTrabajador', 'rutTrabajador', 'cargo', 'lugarTrabajo',
            'direccionTrabajo', 'comunaTrabajo', 'sueldoBase', 'sueldoTexto',
            'fechaInicioContrato', 'representanteLegal', 'rutRepresentante',
            'domicilioEmpresa', 'rutEmpresa'];
        return required.filter(f => isPlaceholder(formData[f])).length;
    };

    // ==================== GENERACION PDF CON PDFMAKE ====================
    const generatePDF = (openInNewTab = false) => {
        const empty = countEmptyFields();
        if (empty > 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Campos incompletos',
                text: `Hay ${empty} campo(s) obligatorio(s) sin completar. ¿Desea generar el PDF de todas formas?`,
                showCancelButton: true,
                confirmButtonText: 'Generar igual',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    buildAndGeneratePDF(openInNewTab);
                }
            });
        } else {
            buildAndGeneratePDF(openInNewTab);
        }
    };

    const buildAndGeneratePDF = (openInNewTab) => {
        generarContratoPDF({ formData, funciones, turnoDia, turnoNoche, logoBase64, openInNewTab });
    };

    // ==================== RENDER ====================
    return (
        <body id="page-top">
            <Sidebar
                imageUrl={imageUrl}
                isComponentsCollapsed={isComponentsCollapsed}
                toggleCollapse={toggleCollapse}
                setIsComponentsCollapsed={setIsComponentsCollapsed}
                isUtilitiesCollapsed={isUtilitiesCollapsed}
                setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                isInventario={isInventario}
                setisIventatioCollapsed={setisIventatioCollapsed}
                isPrevencion={isPrevencion}
                setisPrevencionCollapsed={setisPrevencionCollapsed}
                isLogistica={isLogistica}
                setisLogisticaCollapsed={setisLogisticaCollapsed}
                isContabilidadCollapsed={isContabilidadCollapsed}
                setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                isAdministracionCollapsed={isAdministracionCollapsed}
                setIsAdministracionCollapsed={setIsAdministracionCollapsed}
                cookies={cookies}
            />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <div className="row">
                            {/* ============ PANEL IZQUIERDO: FORMULARIO ============ */}
                            <div className="col-lg-5 col-xl-4">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3 d-flex align-items-center justify-content-between">
                                        <h6 className="m-0 font-weight-bold text-primary">
                                            Módulo de Contratos de {empresa}
                                        </h6>
                                        {countEmptyFields() > 0 && (
                                            <span className="badge bg-warning text-dark">{countEmptyFields()} campos pendientes</span>
                                        )}
                                    </div>
                                    <div className="card-body" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                                        {/* Datos Empresa */}
                                        <AccordionSection id="empresa" isOpen={openSection === 'empresa'} onToggle={toggleSection} title="Datos Empresa" icon="business">
                                            <FormInput label="Ciudad" field="ciudad" value={formData.ciudad} onChange={handleChange} />
                                            <FormInput label="Empresa" field="empresa" value={formData.empresa} onChange={handleChange} />
                                            <FormInput label="RUT Empresa" field="rutEmpresa" placeholder="77.040.719-2" value={formData.rutEmpresa} onChange={handleChange} />
                                            <FormInput label="Rep. Legal" field="representanteLegal" value={formData.representanteLegal} onChange={handleChange} />
                                            <FormInput label="RUT Rep. Legal" field="rutRepresentante" value={formData.rutRepresentante} onChange={handleChange} />
                                            <FormInput label="Domicilio" field="domicilioEmpresa" value={formData.domicilioEmpresa} onChange={handleChange} />
                                            <FormInput label="Email Empleador" field="emailEmpleador" type="email" value={formData.emailEmpleador} onChange={handleChange} />
                                        </AccordionSection>

                                        {/* Datos Trabajador */}
                                        <AccordionSection id="trabajador" isOpen={openSection === 'trabajador'} onToggle={toggleSection} title="Datos Trabajador" icon="person">
                                            <div className="form-check form-switch mb-2" style={{ backgroundColor: formData.rutProvisorio ? '#fff3cd' : '#f8f9fa', padding: '6px 12px 6px 48px', borderRadius: '4px', border: '1px solid #dee2e6' }}>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="rutProvisorioCheck"
                                                    checked={formData.rutProvisorio}
                                                    onChange={(e) => handleChange('rutProvisorio', e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="rutProvisorioCheck" style={{ fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                                                    Rut Provisorio (extranjero no regularizado)
                                                </label>
                                            </div>
                                            <FormInput label="Nombre completo" field="nombreTrabajador" placeholder="NOMBRE APELLIDO APELLIDO" value={formData.nombreTrabajador} onChange={handleChange} />
                                            <FormInput label={formData.rutProvisorio ? "DNI" : "RUT"} field="rutTrabajador" placeholder={formData.rutProvisorio ? "32.406.483" : "12.345.678-9"} value={formData.rutTrabajador} onChange={handleChange} />
                                            {formData.rutProvisorio && (
                                                <>
                                                    <FormInput label="Rut Provisorio" field="rutProvisorioNumero" placeholder="44.610.246-K" value={formData.rutProvisorioNumero} onChange={handleChange} />
                                                    <FormInput label="N° Contacto" field="numeroContacto" placeholder="965260364" value={formData.numeroContacto} onChange={handleChange} />
                                                </>
                                            )}
                                            <FormInput label="Nacionalidad" field="nacionalidad" value={formData.nacionalidad} onChange={handleChange} />
                                            <FormInput label="Fecha Nacimiento" field="fechaNacimiento" type="date" value={formData.fechaNacimiento} onChange={handleChange} />
                                            <FormInput label="Estado Civil" field="estadoCivil" options={["SOLTERO", "CASADO", "DIVORCIADO", "VIUDO", "CONVIVIENTE CIVIL"]} value={formData.estadoCivil} onChange={handleChange} />
                                            <FormInput label="AFP" field="afp" options={["CAPITAL", "CUPRUM", "HABITAT", "MODELO", "PLANVITAL", "PROVIDA", "UNO"]} value={formData.afp} onChange={handleChange} />
                                            <FormInput label="Previsión Salud" field="previsionSalud" options={["FONASA", "ISAPRE BANMÉDICA", "ISAPRE COLMENA", "ISAPRE CRUZ BLANCA", "ISAPRE NUEVA MASVIDA", "ISAPRE VIDA TRES"]} value={formData.previsionSalud} onChange={handleChange} />
                                            <FormInput label="Domicilio" field="domicilioTrabajador" value={formData.domicilioTrabajador} onChange={handleChange} />
                                            <FormInput label="Comuna" field="comunaTrabajador" value={formData.comunaTrabajador} onChange={handleChange} />
                                            <FormInput label="Email" field="emailTrabajador" type="email" value={formData.emailTrabajador} onChange={handleChange} />
                                        </AccordionSection>

                                        {/* Datos del Cargo */}
                                        <AccordionSection id="cargo" isOpen={openSection === 'cargo'} onToggle={toggleSection} title="Datos del Cargo" icon="work">
                                            <FormInput label="Cargo" field="cargo" placeholder="APOYO INTEGRAL DE PRODUCCIÓN" value={formData.cargo} onChange={handleChange} />
                                            <FormInput label="Lugar Trabajo" field="lugarTrabajo" placeholder="BODEGA GOLONDRINAS" value={formData.lugarTrabajo} onChange={handleChange} />
                                            <FormInput label="Dirección Trabajo" field="direccionTrabajo" value={formData.direccionTrabajo} onChange={handleChange} />
                                            <FormInput label="Comuna Trabajo" field="comunaTrabajo" value={formData.comunaTrabajo} onChange={handleChange} />
                                            <hr className="my-2" />
                                            <label className="form-label" style={{ fontSize: '12px', fontWeight: '600' }}>Funciones del cargo:</label>
                                            {funciones.map((f, i) => (
                                                <div key={i} className="d-flex align-items-center mb-1" style={{ fontSize: '11px' }}>
                                                    <span className="me-1">•</span>
                                                    <span className="flex-grow-1">{f}</span>
                                                    <button
                                                        className="btn btn-sm btn-outline-danger py-0 px-1"
                                                        onClick={() => eliminarFuncion(i)}
                                                        style={{ fontSize: '10px', lineHeight: '1.2' }}
                                                    >×</button>
                                                </div>
                                            ))}
                                            <div className="input-group input-group-sm mt-2">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={nuevaFuncion}
                                                    onChange={(e) => setNuevaFuncion(e.target.value)}
                                                    placeholder="Agregar función..."
                                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); agregarFuncion(); } }}
                                                />
                                                <button className="btn btn-sm btn-outline-primary" onClick={agregarFuncion}>+</button>
                                            </div>
                                        </AccordionSection>

                                        {/* Condiciones Laborales */}
                                        <AccordionSection id="condiciones" isOpen={openSection === 'condiciones'} onToggle={toggleSection} title="Condiciones Laborales" icon="payments" maxHeight="1600px">
                                            <FormInput label="Horas semanales" field="horasSemanales" value={formData.horasSemanales} onChange={handleChange} />
                                            <hr className="my-2" />

                                            {/* Turno de día */}
                                            <label className="form-label" style={{ fontSize: '12px', fontWeight: '600' }}>Turno de día (Lun–Sáb):</label>
                                            {turnoDia.map((linea, i) => (
                                                <div key={i} className="input-group input-group-sm mb-1">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        style={{ fontSize: '11px' }}
                                                        value={linea}
                                                        onChange={(e) => modificarLineaDia(i, e.target.value)}
                                                    />
                                                    <button className="btn btn-sm btn-outline-danger" onClick={() => eliminarLineaDia(i)} style={{ fontSize: '11px' }}>×</button>
                                                </div>
                                            ))}
                                            <div className="input-group input-group-sm mt-1 mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={nuevaLineaDia}
                                                    onChange={(e) => setNuevaLineaDia(e.target.value)}
                                                    placeholder="Agregar línea de turno día..."
                                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); agregarLineaDia(); } }}
                                                />
                                                <button className="btn btn-sm btn-outline-primary" onClick={agregarLineaDia}>+</button>
                                            </div>

                                            {/* Turno de noche (rotación) */}
                                            <label className="form-label" style={{ fontSize: '12px', fontWeight: '600' }}>Turno de noche (rotación):</label>
                                            {turnoNoche.map((row, i) => (
                                                <div key={i} className="border rounded p-2 mb-1" style={{ backgroundColor: '#f8f9fa' }}>
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <span style={{ fontSize: '11px', fontWeight: '600' }}>Día trabajado {i + 1}</span>
                                                        <button className="btn btn-sm btn-outline-danger py-0 px-1" onClick={() => eliminarFilaNoche(i)} style={{ fontSize: '11px', lineHeight: '1.2' }}>×</button>
                                                    </div>
                                                    <div className="d-flex gap-1 mb-1">
                                                        <input className="form-control form-control-sm" style={{ fontSize: '10px' }} placeholder="Entra (día)" value={row.entranteDia} onChange={(e) => modificarFilaNoche(i, 'entranteDia', e.target.value)} />
                                                        <input className="form-control form-control-sm" style={{ fontSize: '10px' }} placeholder="Hora" value={row.entranteHora} onChange={(e) => modificarFilaNoche(i, 'entranteHora', e.target.value)} />
                                                    </div>
                                                    <div className="d-flex gap-1">
                                                        <input className="form-control form-control-sm" style={{ fontSize: '10px' }} placeholder="Sale (día)" value={row.salienteDia} onChange={(e) => modificarFilaNoche(i, 'salienteDia', e.target.value)} />
                                                        <input className="form-control form-control-sm" style={{ fontSize: '10px' }} placeholder="Hora" value={row.salienteHora} onChange={(e) => modificarFilaNoche(i, 'salienteHora', e.target.value)} />
                                                    </div>
                                                </div>
                                            ))}
                                            <button className="btn btn-sm btn-outline-primary mb-2 w-100" onClick={agregarFilaNoche} style={{ fontSize: '11px' }}>+ Agregar fila de noche</button>
                                            <hr className="my-2" />
                                            <FormInput label="Sueldo Base ($)" field="sueldoBase" placeholder="500.000" value={formData.sueldoBase} onChange={handleChange} />
                                            <FormInput label="Sueldo (texto)" field="sueldoTexto" placeholder="quinientos mil pesos" value={formData.sueldoTexto} onChange={handleChange} />
                                            <FormInput label="Bono Moviliz. ($)" field="bonoMovilizacion" value={formData.bonoMovilizacion} onChange={handleChange} />
                                            <FormInput label="Bono (texto)" field="bonoMovilizacionTexto" value={formData.bonoMovilizacionTexto} onChange={handleChange} />
                                        </AccordionSection>

                                        {/* Tipo y Vigencia */}
                                        <AccordionSection id="vigencia" isOpen={openSection === 'vigencia'} onToggle={toggleSection} title="Tipo y Vigencia" icon="event">
                                            <FormInput label="Tipo Contrato" field="tipoContrato" options={["PLAZO FIJO", "INDEFINIDO"]} value={formData.tipoContrato} onChange={handleChange} />
                                            <FormInput label="Fecha Inicio" field="fechaInicioContrato" type="date" value={formData.fechaInicioContrato} onChange={handleChange} />
                                            {formData.tipoContrato === "PLAZO FIJO" && (
                                                <FormInput label="Fecha Término" field="fechaFinContrato" type="date" value={formData.fechaFinContrato} onChange={handleChange} />
                                            )}
                                        </AccordionSection>

                                        {/* Botones de acción */}
                                        <div className="d-flex gap-2 mt-3 flex-wrap">
                                            <button className="btn btn-success flex-fill" onClick={() => generatePDF(false)}>
                                                <span className="material-symbols-rounded" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '4px' }}>download</span>
                                                Descargar PDF
                                            </button>
                                            <button className="btn btn-primary flex-fill" onClick={() => generatePDF(true)}>
                                                <span className="material-symbols-rounded" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '4px' }}>visibility</span>
                                                Vista previa
                                            </button>
                                        </div>
                                        <div className="d-grid mt-2">
                                            <button className="btn btn-warning" onClick={registrarTrabajador}>
                                                <span className="material-symbols-rounded" style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '4px' }}>person_add</span>
                                                Registrar trabajador y generar PDF
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ============ PANEL DERECHO: VISTA PREVIA ============ */}
                            <div className="col-lg-7 col-xl-8">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Vista Previa del Contrato</h6>
                                    </div>
                                    <div className="card-body" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', backgroundColor: '#e9ecef' }}>
                                        <div
                                            ref={previewRef}
                                            style={{
                                                backgroundColor: '#fff',
                                                padding: '50px 50px',
                                                maxWidth: '750px',
                                                margin: '0 auto',
                                                boxShadow: '0 2px 15px rgba(0,0,0,0.15)',
                                                fontFamily: 'Georgia, "Times New Roman", serif',
                                                fontSize: '12px',
                                                lineHeight: '1.6',
                                                color: '#222'
                                            }}
                                        >
                                            <h4 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '25px', letterSpacing: '2px' }}>
                                                CONTRATO DE TRABAJO
                                            </h4>

                                            <p style={{ textAlign: 'justify' }}>
                                                En {renderText(formData.ciudad, "Ciudad")}, a {formData.fechaInicioContrato ? formatFecha(formData.fechaInicioContrato) : renderText("", "Fecha")}, entre {renderText(formData.empresa, "Empresa")}, R.U.T {renderText(formData.rutEmpresa, "RUT Empresa")}, representada legalmente por don(a) {renderText(formData.representanteLegal, "Representante Legal")} cédula de identidad {renderText(formData.rutRepresentante, "RUT Representante")}, ambos con domicilio en {renderText(formData.domicilioEmpresa, "Domicilio Empresa")}, en adelante el &ldquo;Empleador&rdquo; y don(a) {renderText(formData.nombreTrabajador, "Nombre Trabajador")}, {formData.rutProvisorio ? "DNI " : "Rut "}{renderText(formData.rutProvisorio ? formData.rutTrabajador : formatRut(formData.rutTrabajador), formData.rutProvisorio ? "DNI" : "RUT Trabajador")}, nacionalidad {renderText(formData.nacionalidad, "Nacionalidad")}, nacido el {formData.fechaNacimiento ? formatFecha(formData.fechaNacimiento) : renderText("", "Fecha Nacimiento")}, estado civil {renderText(formData.estadoCivil, "Estado Civil")}, Previsión {renderText(formData.previsionSalud, "Previsión Salud")}, Cotizante AFP {renderText(formData.afp, "AFP")}, {formData.rutProvisorio && <>Rut Provisorio {renderText(formatRut(formData.rutProvisorioNumero), "Rut Provisorio")}, </>}domiciliado {renderText(formData.domicilioTrabajador, "Domicilio Trabajador")}, comuna de {renderText(formData.comunaTrabajador, "Comuna Trabajador")}, en adelante &ldquo;Trabajador&rdquo;. Se ha convenido el siguiente <strong>CONTRATO DE TRABAJO:</strong>
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>PRIMERO:</strong> El trabajador se compromete y obliga a prestar servicios como {renderText(formData.cargo, "Cargo")} u otro trabajo o función similar, que tenga directa relación con el cargo ya indicado, en las dependencias de {renderText(formData.lugarTrabajo, "Lugar Trabajo")}, {renderText(formData.direccionTrabajo, "Dirección Trabajo")}, comuna de {renderText(formData.comunaTrabajo, "Comuna Trabajo")}, en donde es enviado por {renderText(formData.empresa, "Empresa")} a prestar los servicios para lo que es contratado. Las funciones que el trabajador realizará son:
                                            </p>
                                            <ul style={{ marginLeft: '20px' }}>
                                                {funciones.map((f, i) => (
                                                    <li key={i} style={{ marginBottom: '3px' }}>{f}</li>
                                                ))}
                                            </ul>
                                            <p style={{ textAlign: 'justify' }}>
                                                Se deja establecido que el trabajador se regirá por el artículo 38 del Código del Trabajo, esto es, se encontrará exceptuado del descanso dominical y de días festivos, atendido a la naturaleza de las funciones que realiza. Tendrá derecho a los días de descanso compensatorio por los domingos y festivos trabajados.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>SEGUNDO: JORNADA DE TRABAJO.</strong> El trabajador cumplirá una jornada semanal ordinaria de {renderText(formData.horasSemanales, "Horas Semanales")} horas, distribuida en los siguientes turnos rotativos:
                                            </p>
                                            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '6px', fontSize: '11px' }}>
                                                <thead>
                                                    <tr style={{ backgroundColor: '#e9ecef' }}>
                                                        <th style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'center' }}>TURNO DE DÍA — LUNES A SÁBADO</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {turnoDia.map((linea, i) => (
                                                        <tr key={i}><td style={{ border: '1px solid #ccc', padding: '4px' }}>{linea}</td></tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <p style={{ textAlign: 'justify', marginBottom: '6px' }}>
                                                Descanso de 60 minutos para colación, excepto y únicamente el día sábado.
                                            </p>
                                            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '10px', fontSize: '11px' }}>
                                                <thead>
                                                    <tr style={{ backgroundColor: '#e9ecef' }}>
                                                        <th colSpan={3} style={{ border: '1px solid #888', padding: '6px', textAlign: 'center' }}>TURNO DE NOCHE — LUNES A VIERNES</th>
                                                    </tr>
                                                    <tr style={{ backgroundColor: '#f1f3f5' }}>
                                                        <th style={{ border: '1px solid #888', padding: '4px', textAlign: 'center' }}>Día trabajado</th>
                                                        <th style={{ border: '1px solid #888', padding: '4px', textAlign: 'center' }}>Entrada</th>
                                                        <th style={{ border: '1px solid #888', padding: '4px', textAlign: 'center' }}>Salida</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {turnoNoche.map((row, i) => (
                                                        <tr key={i}>
                                                            <td style={{ border: '1px solid #888', padding: '4px', textAlign: 'center' }}>{i + 1}</td>
                                                            <td style={{ border: '1px solid #888', padding: '4px', textAlign: 'center' }}>{`${row.entranteDia || ''} ${row.entranteHora || ''}`.trim()}</td>
                                                            <td style={{ border: '1px solid #888', padding: '4px', textAlign: 'center' }}>{`${row.salienteDia || ''} ${row.salienteHora || ''}`.trim()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <p style={{ textAlign: 'justify' }}>
                                                Descanso de 60 minutos para colación.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>TERCERO:</strong> El trabajador no se encuentra autorizado para realizar horas extraordinarias, sin autorización del empleador.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>CUARTO:</strong> El empleador se compromete a remunerar los servicios del trabajador, los primeros 06 de cada mes vencido, con un sueldo base mensual de ${renderText(formData.sueldoBase, "Sueldo Base")} ({renderText(formData.sueldoTexto, "Sueldo en Texto")}).
                                            </p>
                                            <p style={{ textAlign: 'justify', marginLeft: '15px' }}>
                                                <strong>Bono de movilización:</strong> ${renderText(formData.bonoMovilizacion, "Bono")} no imponibles ({renderText(formData.bonoMovilizacionTexto, "Bono Texto")}) por día efectivamente trabajado.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>QUINTO:</strong> El trabajador acepta y autoriza las deducciones legales vigentes y descuentos por tiempo no trabajado. Los atrasos reiterados y ausencias injustificadas darán lugar a terminación inmediata del contrato.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>SEXTO:</strong> Gratificación anual equivalente al 25% del total de las remuneraciones mensuales, con tope de 4,75 Ingresos Mínimos.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>SÉPTIMO:</strong> Registro de asistencia según artículo N°21 del Código del Trabajo.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>OCTAVO:</strong> Regulación general sobre todo tipo de permisos.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>NOVENO:</strong> Obligaciones del trabajador según Reglamento de Orden, Higiene y Seguridad.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>DÉCIMO:</strong> EPP, instructivos de gestión de seguridad, deber de cuidado (Art. 184) y obligaciones de prevención. El incumplimiento atiende al Art. 160 N°7 del Código del Trabajo.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>DÉCIMO PRIMERO:</strong> El presente contrato regirá con carácter de {renderText(formData.tipoContrato, "Tipo Contrato")} desde el día {formData.fechaInicioContrato ? formatFecha(formData.fechaInicioContrato) : renderText("", "Fecha Inicio")} hasta el {formData.fechaFinContrato ? formatFecha(formData.fechaFinContrato) : renderText("", "Fecha Fin")}, periodo denominado de "PRUEBA"; pasada la evaluación, el contrato pasará automáticamente a 3 meses desde la fecha de ingreso.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>DÉCIMO SEGUNDO:</strong> Desvinculación por solicitud de la empresa mandante.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>DÉCIMO TERCERO:</strong> Cláusula de confidencialidad.
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>DÉCIMO CUARTO:</strong> Régimen previsional chileno.
                                            </p>

                                            {formData.rutProvisorio && (
                                                <>
                                                    <p style={{ textAlign: 'justify' }}>
                                                        <strong>DÉCIMO QUINTO:</strong> Incumplimiento grave de las obligaciones que impone el contrato. De acuerdo con lo establecido en el código del trabajo Causales del artículo 160: se invocará esta causal dando término inmediato al contrato de trabajo siempre y cuando el trabajador de nacionalidad extranjera contratado no cumpla con la renovación de documentos migratorios (cédula/pasaporte vigente, certificado de antecedentes apostillado, autodenuncia PDI, Rut provisorio cotizante, afiliación a salud chilena). El trabajador se compromete a concretar su proceso migratorio dentro de la vigencia del contrato (no superior a 11 meses).
                                                    </p>
                                                    <p style={{ textAlign: 'justify' }}>
                                                        <strong>DÉCIMO SEXTO:</strong> Del viaje. El empleador no se compromete a pagar, al término de la relación laboral, el pasaje de regreso del trabajador ni de su familia a su país de origen, ya que el trabajador se encontraba con residencia en el país al momento de ser contratado.
                                                    </p>
                                                </>
                                            )}

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>{formData.rutProvisorio ? 'DÉCIMO SÉPTIMO:' : 'DÉCIMO QUINTO:'}</strong> Correos electrónicos: Empleador: {renderText(formData.emailEmpleador, "Email Empleador")} | Trabajador: {renderText(formData.emailTrabajador, "Email Trabajador")}
                                            </p>

                                            <p style={{ textAlign: 'justify' }}>
                                                <strong>{formData.rutProvisorio ? 'DÉCIMO OCTAVO:' : 'DÉCIMO SEXTO:'}</strong> Domicilio en la comuna de {renderText(formData.ciudad, "Ciudad")}.
                                            </p>

                                            <p style={{ textAlign: 'justify', fontStyle: 'italic' }}>
                                                El presente contrato de trabajo se firma en tres ejemplares en este mismo acto uno en poder de cada contratante.
                                            </p>

                                            {/* Firmas */}
                                            <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '60px' }}>
                                                <div style={{ textAlign: 'center', width: '40%' }}>
                                                    <div style={{ borderBottom: '1px solid #000', marginBottom: '8px', height: '40px' }}></div>
                                                    <strong>{formData.nombreTrabajador || "[Nombre Trabajador]"}</strong>
                                                    <div style={{ fontSize: '10px', color: '#666' }}>
                                                        {formData.rutProvisorio
                                                            ? `Rut Provisorio ${formatRut(formData.rutProvisorioNumero) || "[Rut Provisorio]"}`
                                                            : `RUT ${formatRut(formData.rutTrabajador) || "[RUT]"}`}
                                                    </div>
                                                </div>
                                                <div style={{ textAlign: 'center', width: '40%' }}>
                                                    <div style={{ borderBottom: '1px solid #000', marginBottom: '8px', height: '40px' }}></div>
                                                    <strong>{formData.empresa || "[Empresa]"}</strong>
                                                    <div style={{ fontSize: '10px', color: '#666' }}>{formData.rutEmpresa || "[RUT Empresa]"}</div>
                                                    <div style={{ fontSize: '10px', color: '#666' }}>PP. {formData.representanteLegal || "[Representante Legal]"}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </body>
    );
}

export default Contratos;
